import React, { Component } from "react";
import { Grid, GridColumn, GridToolbar } from '@progress/kendo-react-grid';
import { Button } from "@progress/kendo-react-buttons";
import axios from 'axios';
import { withState } from "./with-state";
import GridLoading from "../../Loaders/GridLoading";
import { parseDate } from '@telerik/kendo-intl';
import {orderBy} from '@progress/kendo-data-query';
import { FilterDateString } from "../../Inputs/FilterDateString";
import BenchmarkIndexesPopup from './BenchmarkIndexesPopup';
import InputDateFilterCell from "../../Inputs/InputDateFilterCell";
const StatefulGrid = withState(Grid);

const cloneProduct = (product) => ({ ...product });

class BenchmarkIndexes extends Component {

    constructor(props) {
        super(props);
        this.state = {
            data: [],
            benchmarkIndexes: [],
            gridFilter: undefined,
            filterable: props.styleSettings.showFilters,
            sort: [{ field: 'SortOrder', dir: 'asc' }],
            fileDownload: []
        }
    }

    componentDidMount = () => {
        this.getBenchmarkIndexes();
    }

    getBenchmarkIndexes = () => {
        this.setState({ refreshText: 'Loading...', reportSelected: false, reportSelect: '', });
        var benchmarkIndexes = [];

        const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };

        axios(`api/getBenchmarkIndexes`, {
            method: 'GET',
            params: { company: this.props.user.company },
            headers: headers,
        })
            .then(response => {

                response.data.data.forEach(benchmarkIndex => {

                    if (benchmarkIndex.AsOfDate) {
                        benchmarkIndex.AsOfDate = this.getDate(benchmarkIndex.AsOfDate, true);
                    }
                    benchmarkIndex.IndexDescription = benchmarkIndex.IndexDescription.replace(/\\n/g, '\n')
                    benchmarkIndexes.push(benchmarkIndex)

                })
                this.setState({ data: benchmarkIndexes.map(cloneProduct), benchmarkIndexes: benchmarkIndexes, refreshText: '' })

            })
            .catch(err => {
                console.error(err);
                this.setState({ refreshText: '' });
            })
    }

    selectionChange(event, gFiles) {
        gFiles.forEach(item => {
            if (item.id !== event.dataItem.id) {
                item.selected = false
            }
        });
        event.dataItem.selected = !event.dataItem.selected;
        var selectedFiles = [];
        for (let i = 0; i < gFiles.length; i++) {
            if (gFiles[i].selected) {
                selectedFiles.push(gFiles[i]);
            }
        }
        this.setState({ fileDownload: selectedFiles }, () => { this.forceUpdate(); });
        if (selectedFiles.length > 0) {
            this.setState({ fileSelected: true });
        }
        else {
            this.setState({ fileSelected: false });
        }
        this.forceUpdate();
    }

    headerSelectionChange = (event, gFiles) => {
        const checked = event.syntheticEvent.target.checked;
        gFiles.forEach(item => item.selected = checked);
        var selectedFiles = [];
        for (let i = 0; i < gFiles.length; i++) {
            if (gFiles[i].selected) {
                selectedFiles.push(gFiles[i]);
            }
        }
        this.setState({ fileDownload: selectedFiles });
        if (selectedFiles.length > 0) {
            this.setState({ fileSelected: true });
        }
        else {
            this.setState({ fileSelected: false });
        }
        this.forceUpdate();
    }

    getDate = (sqlDate, isUTC) => {
        var d = parseDate(sqlDate, "yyyy-MM-ddTHH:mm:ss.SSSXXX");
        var utc = new Date(d.getUTCFullYear(), d.getUTCMonth(), d.getUTCDate());
        if (isUTC)
            return utc;
        else
            return d;
    }

    headerCellRender = (thElement, cellProps) => {
        if (thElement !== null) {
            if (cellProps.field === 'selected')
                return (
                    <div />
                );
            else {
                return thElement
            }
        }
        else {
            return thElement;
        }
    }

    refreshBenchmarkIndexes = () => {
        this.setState({ fileDownload: [], fileSelected: false });
        this.getBenchmarkIndexes();
    }

    onDelete = (e) => {
        
        var confirm = window.confirm("Are you sure you want to delete the benchmark index?");

        if (confirm) {
            const headers = { 'authorization': 'Bearer '.concat(this.props.idToken) };
            var payload = {
                benchmarkIndexes: this.state.fileDownload,
                company: this.props.user.company,
            };
            axios.post('api/deleteBenchmarkIndexes', payload, { headers }).then(response => {
                if (response.data.code === 200) {
                    this.setState({ fileDownload: [], fileSelected: false });
                    this.getBenchmarkIndexes();
                }
                else {
                    alert("Error: Could not be deleted.");
                    this.setState({ fileDownload: [], fileSelected: false });
                    this.getBenchmarkIndexes();
                }
            }).catch(e => console.log(e));
        }
    }

    processData = () => {
      const { data, sort, gridFilter } = this.state;

      // first sort
      let sorted = orderBy(data, sort);

      // then filter using FilterDateString
      let filtered = gridFilter ? FilterDateString.filterData(sorted, gridFilter) : sorted;

      return filtered;
    };

    render() {
        return (
            <div className='benchmarkIndexes'>

                <StatefulGrid data={this.processData(this.state.data)}
                    selectedField='selected'
                    onSelectionChange={(e) => this.selectionChange(e, this.state.benchmarkIndexes)}
                    onRowClick={(e) => this.selectionChange(e, this.state.benchmarkIndexes)}
                    onHeaderSelectionChange={(e) => this.headerSelectionChange(e, this.state.benchmarkIndexes)}
                    headerCellRender={this.headerCellRender}
                    filterable={this.state.filterable}
                    filter={this.state.gridFilter}
                    onFilterChange={(e)=>{this.setState({gridFilter:e.filter})}}
                    resizable
                >
                    <GridToolbar>
                        <Button icon='refresh' title='Refresh' onClick={this.refreshBenchmarkIndexes}>{this.state.refreshText}</Button>
                        <Button icon='filter' title='Filter' onClick={(e) => this.setState({ filterable: !this.state.filterable })}>Filter</Button>
                        <BenchmarkIndexesPopup idToken={this.props.idToken} uploadMethod={this.refreshBenchmarkIndexes} files={this.state.benchmarkIndexes} company={this.props.user.company} user={this.props.user} uploadUser={this.props.uploadUser} type='reportStaticContent' button={<Button className="docButton" icon="upload">New</Button>} />
                        {this.props.uploadUser.role === 'admin' && (<BenchmarkIndexesPopup idToken={this.props.idToken} benchmarkIndexEdit={this.state.fileDownload[0]} uploadMethod={this.refreshBenchmarkIndexes} files={this.state.benchmarkIndexes} company={this.props.user.company} user={this.props.user} uploadUser={this.props.uploadUser} button={<Button className="docButton" disabled={this.state.fileDownload.length !== 1} icon='edit'>Edit</Button>} />)}
                        {this.props.uploadUser.role === 'admin' && (<Button className="docButton" disabled={!this.state.fileSelected} onClick={this.onDelete} icon='delete'>Delete Benchmark Index</Button>)}
                    </GridToolbar>
                    <GridColumn
                        width='150px'
                        field="IndexEntityCode"
                        title="Index Entity Code"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.IndexEntityCode}
                            </td>
                        }
                    />
                    <GridColumn
                        field="IndexDescription"
                        title="Index Description"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.IndexDescription}
                            </td>
                        }
                    />
                    <GridColumn
                        width='150px'
                        field="IndexValue"
                        title="Index Value"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.IndexValue}
                            </td>
                        }
                    />
                    <GridColumn
                        width='150px'
                        field="AsOfDate"
                        title="As of Date"
                        headerClassName='gridHeader'
                        filterCell={InputDateFilterCell}
                        filter="date"
                        format="{0:d}"
                    />
                    <GridColumn
                        width='150px'
                        field="Blend"
                        title="Blend"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.Blend}
                            </td>
                        }
                    />
                    <GridColumn
                        width='150px'
                        field="UserDef1"
                        title="User Def 1"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.UserDef1}
                            </td>
                        }
                    />
                    <GridColumn
                        width='150px'
                        field="UserDef2"
                        title="User Def 2"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.UserDef2}
                            </td>
                        }
                    />
                    <GridColumn
                        width='150px'
                        field="UserDef3"
                        title="User def 3"
                        headerClassName='gridHeader'
                        cell={(props) =>
                            <td>
                                {props.dataItem.UserDef3}
                            </td>
                        }
                    />
                </StatefulGrid>
                {this.state.refreshText && <GridLoading gridClass='webRep' />}
            </div>
        );
    }

}

export default BenchmarkIndexes;